import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
} from '@mui/material';
import React from 'react';

import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { DataCol } from './components/DataCol';
import { HeaderCol } from './components/HeaderCol';
import { styles } from './styles';

const getValue = (value, data, reportId) =>
  (value && typeof value === 'function' ? value(data, reportId) : value) || null;

const CollapseLocal = ({ data, columnsWidth, columnConfig, showLeadingLines, getDataArray }) => {
  const rows = getDataArray(data);
  return (
    <Accordion sx={styles.accordion} square>
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}>
        <Box sx={styles.grid(columnsWidth)}>
          {columnConfig.map((col, idx) => (
            <HeaderCol
              key={`header-${data.id}-${idx}`}
              type={col.type}
              value={getValue(col.headerValue, data)}
              addition={getValue(col.headerAddition, data)}
              subtitle={getValue(col.headerSubtitle, data)}
              icon={getValue(col.icon, data)}
            />
          ))}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>
        <Box sx={styles.gridVersions(columnsWidth)}>
          {rows.map((row, index) => {
            const isLast = index === rows.length - 1;
            return (
              <React.Fragment key={`row-fragment-${data.id}-${row.id}-${index}`}>
                {columnConfig.map((col, idx) => (
                  <DataCol
                    key={`details-${data.id}-${row.id}-${index}-${idx}`}
                    type={col.type}
                    value={getValue(col.value, row, data.id)}
                    addition={getValue(col.addition, row)}
                    status={getValue(col.status, row)}
                    isLast={isLast}
                    showLeadingLines={showLeadingLines}
                  />
                ))}

                <div />
              </React.Fragment>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export const CollapseStack = ({
  data,
  columnConfig,
  showLeadingLines = true,
  getDataArray,
  loading = false,
}) => {
  const columnsWidth = columnConfig.map((col) => col.width || '1fr');

  if (loading) {
    return (
      <Box sx={styles.loading}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <Box>
      {data.map((item, idx) => (
        <CollapseLocal
          key={`row-${item.id}-${idx}`}
          data={item}
          columnConfig={columnConfig}
          columnsWidth={columnsWidth}
          showLeadingLines={showLeadingLines}
          getDataArray={getDataArray}
        />
      ))}
    </Box>
  );
};
